var v35 = require('./lib/v35.js');
var sha1 = require('./lib/sha1');
module.exports = v35('v5', 0x50, sha1);



//////////////////
// WEBPACK FOOTER
// ./~/uuid/v5.js
// module id = 444
// module chunks = 35